import { useEffect, useState } from "react";
import { PlayCircle, X } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useAuth } from "@/lib/auth";

export const openTour = () => window.dispatchEvent(new Event("tour-open"));

const src = () => (window.innerWidth < 768 ? "/videos/intro-vertical.mp4" : "/videos/intro-horizontal.mp4");

// 60-second app tour: auto-opens once for new users, and any time via openTour().
export const IntroVideo = () => {
  const { profile } = useAuth();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const h = () => setOpen(true);
    window.addEventListener("tour-open", h);
    return () => window.removeEventListener("tour-open", h);
  }, []);
  useEffect(() => {
    if (profile && !localStorage.getItem("intro_seen")) { localStorage.setItem("intro_seen", "1"); setOpen(true); }
  }, [profile]);
  const vertical = window.innerWidth < 768;
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className={`bg-black border-[var(--line)] p-0 overflow-hidden ${vertical ? "max-w-[min(92vw,420px)]" : "max-w-4xl"}`} data-testid="intro-video-modal">
        <DialogTitle className="sr-only">How to use BTC Odds Watch</DialogTitle>
        <video src={src()} controls autoPlay playsInline className={`w-full ${vertical ? "max-h-[80vh]" : ""} bg-black`} data-testid="intro-video" />
        <div className="flex items-center justify-between gap-2 p-3 bg-[var(--card)]">
          <span className="text-xs text-slate-400">60-second tour of the app</span>
          <button onClick={() => setOpen(false)} className="btn-primary !h-9 text-xs" data-testid="intro-video-close"><X className="w-3.5 h-3.5" />Start exploring</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export const TourButton = ({ className = "" }) => (
  <button onClick={openTour} className={`btn-ghost ${className}`} data-testid="watch-tour-btn"><PlayCircle className="w-4 h-4 text-[var(--cyan)]" />Watch the 60-sec tour</button>
);
